<template>
  <va-card  class="flex mb-4">
    <va-card-title style="height: 30px;padding:5px;padding-left:20px ">投票管理</va-card-title>
    <va-card-content>
      <div>
        <div>
          <vxe-form :data="toolbar.formData">
            <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
              <template #default="{ data }">
                <vxe-input v-model="data.searchKey" placeholder="请输入主題" clearable></vxe-input>
              </template>
            </vxe-form-item>
            <vxe-form-item title="是否启用" field="isEnable" :item-render="{}">
              <template #default="{ data }">
                <vxe-select v-model="data.isEnable" placeholder="请选择" style="width: 80px" clearable>
                  <vxe-option value="是" label="是"></vxe-option>
                  <vxe-option value="否" label="否"></vxe-option>
                </vxe-select>
              </template>
            </vxe-form-item>
            <vxe-form-item>
              <template #default>
                <vxe-button status="primary" @click="findData" @keyup.enter="findData">查询</vxe-button>
                <vxe-button @click="clear">重置</vxe-button>
                <vxe-button status="success" @click="add">新增</vxe-button>
              </template>
            </vxe-form-item>
          </vxe-form>
        </div>
        <div style="overflow: hidden;height: 100%">
          <vxe-table
            stripe
            class="mytable-scrollbar"
            ref="table"
            :data="tableData"
            :height="tableHeight"
            show-overflow
            :row-config="{height: 36,isHover: true,isCurrent:true}"
          >
            <vxe-column type="seq" field="id" title="序号" width="60"></vxe-column>
            <vxe-column title="编辑" width="60" show-overflow>
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-edit" @click="editVote(row)"></vxe-button>
              </template>
            </vxe-column>
            <vxe-column title="删除" width="60" show-overflow>
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-trash-o" @click="removeVote(row)"></vxe-button>
              </template>
            </vxe-column>
            <vxe-column title="投票结果" width="100" show-overflow>
              <template #default="{ row }">
                <vxe-button type="text" icon="fa fa-bar-chart-o" @click="showResult(row)"></vxe-button>
              </template>
            </vxe-column>
            <vxe-column field="topic" title="主题" width="250" sortable show-overflow></vxe-column>
            <vxe-column field="beginTime" title="开始时间" width="140" sortable show-overflow></vxe-column>
            <vxe-column field="endTime" title="结束时间" width="140" sortable show-overflow></vxe-column>
            <vxe-column field="enabled" title="是否启用" width="100" sortable></vxe-column>
            <vxe-column field="isMulti" title="是否每天投" :visible="false" width="130" sortable show-overflow></vxe-column>
            <vxe-column field="multiCount" title="每天可投数量" width="140" sortable></vxe-column>
            <vxe-column field="creationTime" title="创建时间" width="120"></vxe-column>
            <vxe-column field="creationMan" title="创建人" width="100"></vxe-column>
          </vxe-table>
        </div>
        <div>
          <vxe-pager
            background
            v-model:current-page="tablePager.currentPage"
            v-model:page-size="tablePager.pageSize"
            :total="tablePager.totalResult"
            @page-change="handlePageChange"
            :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
          </vxe-pager>
        </div>
      </div>
      <vxe-modal title="编辑投票" v-model="formInput.isShow" width="800" height="640">
        <template #default>
          <div>
            <vxe-form
              :data="formInput.formData"
              :rules="formInput.formRules"
              ref="rForm">
              <vxe-form-item title="主题" field="topic" span="24" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-input v-model="data.topic" placeholder="请输入主题" clearable></vxe-input>
                </template>
              </vxe-form-item>

              <vxe-form-item title="开始时间" field="beginTime" span="12" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-input v-model="data.beginTime" placeholder="请选择开始时间" clearable type="datetime"
                             transfer></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="结束时间" field="endTime" span="12" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-input v-model="data.endTime" placeholder="请选择结束时间" clearable type="datetime"
                             transfer></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="是否启用" field="enabled" span="12" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-select v-model="data.enabled" clearable placeholder="请选择">
                    <vxe-option value="1" label="是"></vxe-option>
                    <vxe-option value="0" label="否"></vxe-option>
                  </vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="是否多选" field="isMulti" :visible="false" span="12" :item-render="{}"
                             title-width="100px">
                <template #default="{ data }">
                  <vxe-select v-model="data.isMulti" placeholder="请选择" clearable>
                    <vxe-option value="0" label="否"></vxe-option>
                    <vxe-option value="1" label="是"></vxe-option>
                  </vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="每天可投数量" field="multiCount" span="12" :item-render="{}" title-width="120px">
                <template #default="{ data }">
                  <vxe-input v-model="data.multiCount" min="1" max="50" placeholder="每天可投数量" clearable
                             type="integer"></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="投票说明" field="remark" span="24" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-input v-model="data.remark" clearable></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="投票口号" field="slogan" span="24" :item-render="{}" title-width="100px">
                <template #default="{ data }">
                  <vxe-input v-model="data.slogan" clearable></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="参选流程" span="24" title-align="left" title-width="200px"
                             :title-prefix="{icon: 'fa fa-info-circle'}">

              </vxe-form-item>
              <vxe-form-item span="24">
                <template #default>
                  <span>关键字:</span>
                  <vxe-input v-model="toolbarVoteList.formData.searchKey" clearable style="width: 140px"></vxe-input>
                  <vxe-button @click="findDataVoteList" content="查询" size="small" icon="fa fa-search"></vxe-button>
                  <vxe-button @click="selectPublish"
                              size="small" icon="fa fa-plus"
                              content="新增"
                  ></vxe-button>
                  <vxe-button @click="delVoteList"
                              size="small" icon="fa fa-trash-o"
                              content="删除"
                              status="danger"></vxe-button>
                </template>
              </vxe-form-item>

            </vxe-form>
            <div>
              <div>
                <vxe-table
                  ref="xTable"
                  :sort-config="{defaultSort:{field:'processID',order:'asc'}}"
                  :data="formInput.voteList"
                  height="220"
                  highlight-hover-row
                  highlight-current-row
                >
                  <vxe-column type="checkbox" field="id" title="" width="40">
                  </vxe-column>
                  <vxe-column type="seq" title="序号" width="60"></vxe-column>
                  <vxe-column field="processID" title="流程ID" width="120" sortable resizable show-overflow>
                  </vxe-column>
                  <vxe-column field="processName" title="流程名称" width="300" sortable resizable show-overflow>
                  </vxe-column>
                  <vxe-column field="developer" title="开发人员" width="100" sortable resizable show-overflow>
                  </vxe-column>
                  <vxe-column field="division" title="总部" width="100" sortable resizable>
                  </vxe-column>
                  <vxe-column field="dept" title="部门" width="100" sortable resizable>
                  </vxe-column>
                  <vxe-column field="saveTime" title="年节省时间" width="120" sortable resizable>
                  </vxe-column>
                  <vxe-column field="runCount" title="运行次数" width="100" sortable resizable>
                  </vxe-column>
                </vxe-table>
              </div>
              <div>
                <vxe-pager
                  background
                  v-model:current-page="tablePagerVoteList.currentPage"
                  v-model:page-size="tablePagerVoteList.pageSize"
                  :total="tablePagerVoteList.totalResult"
                  @page-change="handlePageChangeVoteList"
                  :layouts="['PrevJump', 'PrevPage', 'JumpNumber', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
                </vxe-pager>
              </div>
            </div>
            <div style=" width: 99%;alignment: center;text-align: center;margin-top: 10px">
              <vxe-button @click="save" icon="fa fa-save"
                          status="success">保存
              </vxe-button>
            </div>
          </div>

        </template>
      </vxe-modal>
      <vxe-modal title="选择流程" v-model="publishToolbar.isShow" width="700">
        <template #default>
          <div>
            <vxe-form>
              <vxe-form-item title="关键字" field="searchKey" :item-render="{}">
                <template #default>
                  <vxe-input v-model="publishToolbar.searchKey" placeholder="请输入流程ID或流程名称" clearable></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item>
                <template #default>
                  <vxe-button @click="findPublishData" @keyup.enter="findPublishData">查询</vxe-button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
          <div>
            <vxe-table
              class="mytable-scrollbar"
              :data="publishToolbar.dtData"
              ref="xTablePublish"
              height="300"
              @cell-dblclick="confirmSelectPublish"
              highlight-hover-row
              highlight-current-row>
              <vxe-column type="checkbox" field="id" title="" width="40">
              </vxe-column>
              <vxe-column type="seq" field="Id" title="序号" width="50"></vxe-column>
              <vxe-column field="ProcessID" title="流程ID" width="140" resizable sortable></vxe-column>
              <vxe-column field="ProcessName" title="流程名称" width="200" show-overflow resizable sortable></vxe-column>
              <vxe-column field="developer" title="开发人员" width="100" sortable show-overflow></vxe-column>
              <vxe-column field="division" title="总部" width="100" sortable show-overflow></vxe-column>
              <vxe-column field="dept" title="部门" width="100" sortable show-overflow></vxe-column>
              <vxe-column field="CoeTeacher" title="COE导师" width="100" sortable show-overflow></vxe-column>
              <vxe-column field="saveTime" title="年节省时间" width="120" sortable resizable>
              </vxe-column>
              <vxe-column field="runCount" title="运行次数" width="100" sortable resizable>
              </vxe-column>
              <vxe-column field="developerUID" title="developerUID" :visible="false" width="100" sortable
                          show-overflow></vxe-column>
            </vxe-table>
          </div>
          <div>
            <vxe-pager
              background
              v-model:current-page="publishToolbar.pager.currentPage"
              v-model:page-size="publishToolbar.pager.pageSize"
              :total="publishToolbar.pager.totalResult"
              @page-change="handlePageChangePublish"
              size="small"
            >
            </vxe-pager>
          </div>
          <div style="width: 100%; float: right;text-align: right">
            <vxe-button status="primary" @click="confirmSelectPublish">选择</vxe-button>
            <vxe-button title="用来初始化或者重置所有流程" status="warning" @click="SelectPublishAll">重置</vxe-button>
          </div>
        </template>
      </vxe-modal>
    </va-card-content>
  </va-card>
  <vxe-modal title="投票结果" v-model="isShowDashbord" width="1000" height="620" maskClosable show-zoom resize>
    <template #default>
      <Ranking v-if="isShowDashbord" :voteID="voteID"></Ranking>
    </template>
  </vxe-modal>
</template>

<script>

import Qs from 'qs'
import {reactive, defineComponent, ref} from 'vue';
import {VXETable, VxeTableInstance, VxeToolbarInstance} from 'vxe-table'
import Ranking from '../vote/components/Ranking'

export default {
  name: "VoteList",
  components: {Ranking},
  data() {
    const pageHeight = window.innerHeight - (65 + 48 + 198) + 'px';//屏幕高度减去导航栏和内补白
    const tablePager = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const tablePagerVoteList = reactive({
      currentPage: 1,
      pageSize: 10,
      totalResult: 0
    })
    const toolbar = reactive({
      loading: false,
      formData: {
        searchKey: '',
        isEnable: ''
      }
    })
    const toolbarVoteList = reactive({
      loading: false,
      formData: {
        searchKey: ''
      }
    })
    const publishToolbar = reactive({
      loading: false,
      isShow: false,
      searchKey: '',
      dtData: [],
      pager: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 0
      }
    })
    const formInput = reactive({
      isShow: false,
      editType: '1',
      formData: {
        id: '',
        topic: '',
        beginTime: '',
        endTime: '',
        enabled: '1',
        isMulti: '0',
        multiCount: 1,
        creationMan: '',
        creationTime: '',
        modifer: '',
        remark: '',
        slogan:''
      },
      formRules: {
        topic: [
          {required: true, message: '主題不能为空'},
        ],
        beginTime: [
          {required: true, message: '开始时间不能为空'}
        ],
        endTime: [
          {required: true, message: '结束不能为空'}],
        isMulti: [
          {required: true, message: '是否多选不能为空'}],
        multiCount: [
          {required: true, message: '多选数量不能为空'}],
        enabled: [
          {required: true, message: '是否启用不能为空'}],
      },
      voteList: []
    })

    return {
      tableData: null,
      tablePager,
      tablePagerVoteList,
      toolbar,
      formInput,
      pageHeight,
      tableHeight: 0,
      toolbarVoteList,
      publishToolbar,
      isShowDashbord: false,
      voteID: ''
    }
  },
  methods: {
    add() {
      this.formInput.isShow = true;
      this.formInput.editType = '1';
      this.formInput.formData = {
        id: this.$utils.guid(),
        topic: '',
        beginTime: '',
        endTime: '',
        enabled: '1',
        isMulti: '0',
        multiCount: 1,
        creationMan: this.getUserId,
        modifer: this.getUserId,
        remark: '',
        slogan:''
      };
      this.formInput.voteList = [];
      this.toolbarVoteList.formData.searchKey = '';
    },
    editVote(row) {
      const params = {
        'uid': this.getUserId,
        'email': this.getUserEmail,
        'currentPage': 1,
        'pageSize': 20,
        'searchKey': [row.id]
      };

      this.$api.systemManageAPI.getVoteOne(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          this.formInput.isShow = true;
          console.log('#############')
          console.log(res.data.Data.dataTable[0])
          this.formInput.formData = res.data.Data.dataTable[0];
          this.formInput.editType = '2';//更新
          this.toolbarVoteList.formData.searchKey = '';
          this.findDataVoteList();
          console.log(this.formInput.formData)
        })
        .catch(error => {
          console.log(error);

        })
    },
    async removeVote(row) {
      const type = await VXETable.modal.confirm('您确定要删除该数据?')
      const $grid = this.$refs.table;

      if (type === 'confirm') {

        this.$api.systemManageAPI.deleteVote(Qs.stringify({"id": row.id}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: "删除成功", status: 'success'});
            $grid.remove(row);
          })
          .catch(error => {
            console.log(error);
          })
      }

    },
    async save() {
      const $rForm = this.$refs.rForm;
      const formErrMap = await $rForm.validate();
      if (formErrMap) {
        return;
      }

      if (this.formInput.voteList.length == 0) {
        VXETable.modal.message({content: '请选择参选流程', status: 'info'});
        return;
      }

      const params = this.formInput.formData;
      //新增
      if (this.formInput.editType === '1') {
        this.$api.systemManageAPI.addVote(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.alert({content: error, status: 'error'});
            console.log(error);
          });
      } else if (this.formInput.editType === '2') { //更新
        this.$api.systemManageAPI.updateVote(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '保存成功', status: 'success'});
            this.formInput.isShow = false;
            this.findData();
          })
          .catch(error => {
            VXETable.modal.message({content: error, status: 'error'});
            console.log(error);
          });
      }
    },
    async delVoteList() {
      const checkboxRecords = this.$refs.xTable.getCheckboxRecords();
      if (checkboxRecords == null || checkboxRecords.length == 0) {
        VXETable.modal.message({content: '请选择数据', status: 'error'});
        return;
      }
      const type = await VXETable.modal.confirm('您确定要删除选择数据吗?')

      let ids = '';

      checkboxRecords.forEach((item) => {
        ids += (',' + item.id + ',')
      })

      if (type === 'confirm') {

        this.$api.systemManageAPI.deleteVoteList(Qs.stringify({"ids": ids}))
          .then(res => {
            if (res.data.Success === false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: "删除成功", status: 'success'});
            this.findDataVoteList();
          })
          .catch(error => {
            console.log(error);
          })
      }
    },
    launchToast(toastMsg) {
      this.$vaToast.init({
        message: toastMsg,
        iconClass: this.toastIcon,
        position: this.toastPosition,
        duration: Number(this.toastDuration),
        fullWidth: this.isToastFullWidth,
      })
    },
    //打开选择发布流程
    selectPublish() {
      this.publishToolbar.searchKey = '';
      this.findPublishData();
      this.publishToolbar.isShow = true;
    },
    showResult(row) {
      this.voteID = row.id;
      this.isShowDashbord = true;
    },
    //查询流程
    findPublishData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.publishToolbar.pager.currentPage,
        'pageSize': this.publishToolbar.pager.pageSize,
        'searchKey': [this.publishToolbar.searchKey, this.formInput.formData.id]
      };
      this.$api.publishManageAPI.getPublishListVote(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          // console.log(res.data.Data);
          this.publishToolbar.dtData = res.data.Data.dataTable;
          this.publishToolbar.pager.currentPage = res.data.Data.currentPage;
          this.publishToolbar.pager.pageSize = res.data.Data.pageSize;
          this.publishToolbar.pager.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    //全选
    async SelectPublishAll() {
      const type = await VXETable.modal.confirm('您确定添加全部流程吗（如果已经存在流程，将会重置）?')
      const $grid = this.$refs.table;

      if (type === 'confirm') {

        const params = {VoteID: this.formInput.formData.id, Type: '1', ProcessList: ''}

        this.$api.systemManageAPI.addVoteList(Qs.stringify(params))
          .then(res => {
            if (res.data.Success == false) {
              VXETable.modal.message({content: res.data.Message, status: 'error'});
              return;
            }
            VXETable.modal.message({content: '添加成功', status: 'success'});
            this.publishToolbar.isShow = false;
            this.findDataVoteList();
          })
          .catch(error => {
            VXETable.modal.message({content: error, status: 'error'});
            console.log(error);
          });
      }
    },
    //选择单个
    confirmSelectPublish() {
      const $table = this.$refs.xTablePublish;
      const record = $table.getCheckboxRecords();
      if (record == null || record.length == 0) {
        VXETable.modal.message({content: '请选择一行数据', status: 'info'});
        return;
      }
      let records = [];
      record.forEach((item) => {
        records.push({
          'ProcessID': item.ProcessID,
          'ProcessName': item.ProcessName,
          'developer': item.developer,
          'division': item.division,
          'dept': item.dept,
          'developerUID': item.developerUID,
          'runCount': item.runCount,
          'saveTime': item.saveTime
        })
      });
      const params = {VoteID: this.formInput.formData.id, Type: '0', ProcessList: records}

      this.$api.systemManageAPI.addVoteList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          VXETable.modal.message({content: '添加成功', status: 'success'});
          this.publishToolbar.isShow = false;
          this.findDataVoteList();
        })
        .catch(error => {
          VXETable.modal.message({content: error, status: 'error'});
          console.log(error);
        });

    },
    handlePageChangePublish() {
      this.findPublishData();
    },
    //查询评选流程清单
    findDataVoteList() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePagerVoteList.currentPage,
        'pageSize': this.tablePagerVoteList.pageSize,
        'searchKey': [this.formInput.formData.id, this.toolbarVoteList.formData.searchKey]
      };
      this.$api.systemManageAPI.getVoteProcessList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // console.log(res.data.Data);
          this.formInput.voteList = res.data.Data.dataTable;
          this.tablePagerVoteList.currentPage = res.data.Data.currentPage;
          this.tablePagerVoteList.pageSize = res.data.Data.pageSize;
          this.tablePagerVoteList.totalResult = res.data.Data.totalResult;

        })
        .catch(error => {
          console.log(error);

        })
    },
    calTableHeight(rowsLength) {
      let minHeight = window.innerHeight - (65 + 28 + 198);
      let calHeight = rowsLength == null ? 0 : (rowsLength + 1) * 36 + 22;
      this.tableHeight = Math.max(minHeight, calHeight);
    },
    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': this.tablePager.currentPage,
        'pageSize': this.tablePager.pageSize,
        'searchKey': [this.toolbar.formData.searchKey, this.toolbar.formData.isEnable]
      };
      this.$api.systemManageAPI.getVoteList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({
                            content: res.data.Message,
                            status: "error",
                        });
            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data.dataTable;
          this.tablePager.currentPage = res.data.Data.currentPage;
          this.tablePager.pageSize = res.data.Data.pageSize;
          this.tablePager.totalResult = res.data.Data.totalResult;
          this.tableHeight = this.$calTableHeight(res.data.Data.dataTable.length);

        })
        .catch(error => {
          console.log(error);

        })
    },
    handlePageChange() {
      this.findData();
    },
    handlePageChangeVoteList() {
      this.findDataVoteList();
    },
    clear() {
      this.toolbar.formData.searchKey = '';
      this.toolbar.formData.isEnable = ''
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    },

  },
  mounted() {
    this.findData();
    this.formInput.formData.creationMan = this.getUserId;
    this.formInput.formData.modifer = this.getUserId;
    window.addEventListener("keydown", this.keydown)
  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);
  },
  computed: {
    getUserName() {
      return this.$store.state.userName;
    },
    getJobZb() {
      return this.$store.state.jobZb;
    },
    getJobName() {
      return this.$store.state.jobName;
    },
    getUserEmail() {
      return this.$store.state.email;
    },
    getUserId() {
      return this.$store.state.userID;
    }
  }
}

</script>


<style type="text/css">
td.vxe-body--column {
  vertical-align: middle;
}
</style>
